<template>
  <div class="edit-sheet-custom-button" v-loading="loading">
    <side-menu
      class="side-menu no-bar"
      :itemList="customBtnList"
      :activeItem="btnInfo"
      :descStr="descStr"
      @create="createBtn"
      @delete="deleteBtn"
      @select="selectBtn"
    ></side-menu>
    <main-content
      class="main-content"
      :btn-info="btnInfo"
      :sheet="sheet.data"
      :available-sheets="availableSheets.data"
      @save="updateBtn"
    ></main-content>
  </div>
</template>

<script>
import * as sheetBtnApi from "@/api/sheet/sheetBtn"
import SideMenu from "../components/side-menu"
import MainContent from "./main-content"
import { deepClone } from "@/utils/common"

export default {
  name: "edit-sheet-custom-button",
  components: {
    MainContent,
    SideMenu
  },
  props: {
    sheet: Object,
    availableSheets: Object,
    controlsMap: Object,
    customBtns: Object
  },
  data() {
    return {
      descStr: "在当前工作表的记录中添加自定义按钮，当用户点击按钮后填写预设的内容或执行一个工作流",
      loading: true, // 加载
      customBtnList: [],
      btnInfo: {} // 当前选中的btn的数据
    }
  },
  methods: {
    init() {
      this.customBtnList = deepClone(this.customBtns.data)
      if (this.customBtnList.length > 0) {
        if (this._.isEmpty(JSON.parse(localStorage.getItem("btnInfo")))) {
          this.selectBtn(this.customBtnList[0])
        } else {
          this.selectBtn(JSON.parse(localStorage.getItem("btnInfo")))
        }
      }
      this.loading = false
    },
    selectBtn(btnInfo) {
      localStorage.removeItem("btnInfo")
      this.btnInfo = btnInfo
      this.$set(this.btnInfo, "verifyIsExcute", !!this.btnInfo.validateFlowId)
    },
    createBtn() {
      this.loading = true
      let newBtn = {
        name: "自定义按钮",
        sheetId: this.sheet.data.sheetId,
        filters: [],
        actionType: "DIRECT",
        confirmMsg: "你确认对记录执行此操作吗？",
        desc: ""
      }
      sheetBtnApi
        .createBtn(newBtn)
        .commonDeal()
        .then(res => {
          this.$message({
            message: "创建按钮成功",
            type: "success"
          })
          this.customBtnList.push(res)
          this.btnInfo = res
          this.$set(this.btnInfo, "verifyIsExcute", !!this.btnInfo.validateFlowId)
          this.output()
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteBtn(btnInfo) {
      let index = this.customBtnList.findIndex(i => i.id == btnInfo.id)
      this.$confirm(`此操作将永久删除该按钮（${btnInfo.name}）, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true
          sheetBtnApi
            .deleteBtn(btnInfo.id)
            .commonDeal()
            .then(res => {
              this.$message({
                message: "删除按钮成功",
                type: "success"
              })
              this.customBtnList.splice(index, 1)
              this.btnInfo = this.customBtnList[0] || {}
              this.$set(this.btnInfo, "verifyIsExcute", !!this.btnInfo.validateFlowId)
              this.output()
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {
          this.$message("操作已取消！")
        })
    },
    updateBtn() {
      localStorage.removeItem("btnInfo")
      this.loading = true
      sheetBtnApi
        .updateBtn(this.btnInfo)
        .commonDeal()
        .then(data => {
          this.$message({
            message: "修改成功",
            type: "success"
          })
          this.output()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 自定义按钮改变后传回父组件
    output() {
      this.$emit("customBtnChange", this.customBtnList)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-sheet-custom-button {
  display: flex;
  .side-menu {
    flex-basis: 300px;
    height: calc(100vh - 55px);
    box-sizing: border-box;
    overflow-y: scroll;
    border-right: 1px solid #ddd;
  }
  .main-content {
    flex: 1 1;
    background-color: #fff;
  }
}
</style>
